import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    pure: false
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], filter: any): any {
        if (!items || items.length === 0 || !filter) {
            return items
        }

        const el = Object.keys(filter)[0];
        // filter items array, items which match and return true will be kept, false will be filtered out
        if (filter[el] === 0) {
            return items
        }

        return items.filter(item => item[el] === filter[el]);
    }
}
